import InfoFormComponent from 'components/forms/info';
import {useWholesaler} from 'context/wholesaler';
import {Form, Formik} from 'formik';
import Header from 'modules/header/wholesaler/main';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import UseGetProvince from 'utilities/hooks/province/useGetProvince';
import {initialValues} from './utilities/initialValues';
import {pageOneSchema} from 'pages/farm/createAd/form/information/utilities/validationSchema';
import useSetInitialProvince from 'utilities/hooks/initialProvince';

const Info = () => {
  const [cities, setCities] = useState<Array<ICity>>([]);
  const navigate = useNavigate();
  const {provinces} = UseGetProvince();
  const {wholesaler, updateWholesalerForm} = useWholesaler();
  const {state, city} = useSetInitialProvince(provinces);
  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      <Formik
        initialValues={initialValues(wholesaler, state, city)}
        validationSchema={pageOneSchema}
        enableReinitialize={true}
        onSubmit={values => {
          updateWholesalerForm(values);
          navigate('/wholesaler/add-ad/quality');
        }}
      >
        {({values}) => {
          if (values.state) {
            const province = provinces?.find(
              x => x.id === Number(values.state),
            );
            setCities(province?.cities || []);
          }
          return (
            <Form className="h-[110vh]">
              <InfoFormComponent cities={cities} values={values} app="market" />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default Info;
